import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import { mutedClass } from '../uiStyles';

const preview = (text) => {
  const single = String(text || '').replace(/\s+/g, ' ').trim();
  return single.length > 90 ? `${single.slice(0, 90)}…` : single;
};

/**
 * The thread column, shared by the user's page and the admin panel. `unreadKey`
 * decides which side's badge is shown, `showUser` adds the sender for the admin.
 */
const ThreadList = ({ threads, activeId, onSelect, unreadKey, showUser = false }) => {
  const { isDarkMode } = useTheme();
  const { t, i18n } = useTranslation();

  if (threads.length === 0) {
    return <p className={`text-sm p-4 ${mutedClass(isDarkMode)}`}>{t('messages.empty')}</p>;
  }

  return (
    <ul className="space-y-2">
      {threads.map((thread) => {
        const unread = thread[unreadKey] > 0;
        const isActive = String(activeId) === String(thread.id);

        return (
          <li key={thread.id}>
            <button
              type="button"
              onClick={() => onSelect(thread.id)}
              className={`w-full text-left p-3 rounded-xl border transition-colors ${isActive
                ? isDarkMode
                  ? 'bg-primary/10 border-primary/40'
                  : 'bg-green-50 border-green-300'
                : isDarkMode
                  ? 'bg-dark/40 border-primary/10 hover:border-primary/30'
                  : 'bg-white border-gray-200 hover:border-gray-300'}`}
            >
              <div className="flex items-start justify-between gap-2">
                <span className={`font-semibold text-sm truncate ${isDarkMode ? 'text-light' : 'text-gray-800'}`}>
                  {thread.subject}
                </span>
                {unread && (
                  <span className="flex-none min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center">
                    {thread[unreadKey]}
                  </span>
                )}
              </div>

              {showUser && (
                <p className={`text-xs mt-0.5 truncate ${isDarkMode ? 'text-primary/80' : 'text-green-700'}`}>
                  {thread.user.name} · {thread.user.email}
                </p>
              )}

              <p className={`text-xs mt-1 line-clamp-2 ${mutedClass(isDarkMode)}`}>
                {thread.lastSender === 'admin' && `${t('messages.adminLabel')}: `}
                {preview(thread.lastBody)}
              </p>

              <p className={`text-[11px] mt-1.5 ${mutedClass(isDarkMode)}`}>
                {new Date(thread.updatedAt).toLocaleString(i18n.language, {
                  dateStyle: 'short',
                  timeStyle: 'short',
                })}
                {' · '}
                {t('messages.messageCount', { count: thread.messageCount })}
              </p>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default ThreadList;
